import { useEffect, useContext, useState } from 'react'
import PropTypes from 'prop-types'

// Context
import { NavigationContext } from '../../context/NavigationContext'

// Internal components
import Svg from '../Svg/Svg'

// Utils
import { readCookie, createCookie } from '../../utils/store/cookies'

const Notification = (props) => {
  const { text, expirationTime } = props

  // context
  const navigationContext = useContext(NavigationContext)
  const [loading, setLoading] = useState(true)

  // reads out cookie to see if consent has already been set and sets context variable accordingly.
  // loading state added ('buys time' in order for the cookie message to render accordingly)
  useEffect(() => {
    setLoading(false)
    navigationContext.setNotificationSeen(readCookie('cookies_notification'))
    // setLoading(false)
  }, [])

  // click handler to set consent.
  const setSeen = (e, seen) => {
    navigationContext.setNotificationSeen(seen)
    // refNotification.current.classList.add('is-hidden')
    createCookie('cookies_notification', seen, Number(expirationTime) / 24)
  }

  const createMarkup = (text) => ({ __html: text })

  // shows cookies message when those are not accepted or declined yet.
  return (
    <>
      {loading ? (
        <></>
      ) : (
        <div className={'Notification is-shown'}>
          <div className="Notification-content">
            <>
              <p className="Notification-copy">
                <>
                  <span className="Notification-alertIcon">!</span>
                  <span className="Notification-text" dangerouslySetInnerHTML={createMarkup(text)}></span>
                </>
              </p>
              <button className="Notification-closeButton" onClick={(e) => setSeen(e, true)}>
                <Svg id={'icon-close'} modifiers={['Notification-closeIcon']} />
              </button>
            </>
          </div>
        </div>
      )}
    </>
  )
}
Notification.propTypes = {
  text: PropTypes.string,
  expirationTime: PropTypes.string
}

export default Notification
